import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminPositionsRoutes: RouteObject[] = [
  {
    path: 'admin/positions',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_POSITIONS, title: 'Postes' },
  },
  {
    path: 'admin/positions/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_POSITION_CREATE, title: 'Nouveau poste' },
  },
  {
    path: 'admin/positions/:positionId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_POSITION_FORM, title: 'Modifier le poste' },
  },
];
